import software1 from "../assets/8.svg";
import software2 from "../assets/chart.svg";
import software3 from "../assets/9.svg";
import software4 from "../assets/10.svg";
import software5 from "../assets/11.svg";
import software6 from "../assets/12.svg";
import type { ServiceItem } from "./solutions";

export const softwareItems: ServiceItem[] = [
    {
        slug: "honesti-crm",
        title: "HonestiIQ",
        headingColor: "#9e00ff",
        tagline: "Optimize Engagement, Maximize Success",
        description:
            "Say goodbye to manual work. Our CRM automates and connects almost everything! Manage social media interactions (Facebook, Instagram, Twitter), messaging (WhatsApp, SMS), e-commerce platforms (IndiaMART, Justdial), email, WooCommerce, and Shopify—all in one central hub. We empower you to build stronger customer relationships with a complete picture",
        image: software1,
        imagePosition: "right",
        desktopImageType: "svg",
    },
    {
        slug: "easyon",
        title: "EasyOn",
        headingColor: "#0891b2",
        tagline: "BUSINESS OPERATIONS AUTOMATION PLATFORM",
        description:
            "Run quotations, billing, inventory, and compliance — all in one workspace built for growing teams.",
        image: software2,
        imagePosition: "left",
        desktopImageType: "svg",
    },
    {
        slug: "whatsapp-bulk-sender",
        title: "Whatsapp Bulk Sender",
        headingColor: "#002454",
        tagline: "Bulk Send with Precision and Speed",
        description:
            "We empower businesses to connect with their customers on WhatsApp at scale. Our bulk messaging software allows for targeted campaigns, personalization, and insightful analytics, helping you build stronger relationships and drive business growth.",
        image: software3,
        imagePosition: "left",
        desktopImageType: "svg",
    },
    {
        slug: "socialmedia-automation-software",
        title: "Socialmedia Automation Software",
        headingColor: "#9e00ff",
        tagline: "Automate, Connect, Grow",
        description:
            "We become your social media sidekick. Our automation software takes care of scheduling and posting, so you can focus on creating engaging content and interacting with your audience.",
        image: software4,
        imagePosition: "right",
        desktopImageType: "svg",
    },
    {
        slug: "whatsapp-api-platform",
        title: "Whatsapp API Platform",
        headingColor: "#002454",
        tagline: "Automate WhatsApp, Accelerate Growth",
        description:
            "We transform customer experiences with WhatsApp. Our API platform empowers you to send rich media messages, personalize interactions based on customer behavior, and deliver exceptional support, all within the familiar environment of WhatsApp.",
        image: software5,
        imagePosition: "left",
        desktopImageType: "svg",
    },
    {
        slug: "sms-call-email-broadcast",
        title: "Sms, Call & Email Broadcast",
        headingColor: "#9e00ff",
        tagline: "Effortless Broadcast, Effective Results",
        description:
            "We streamline communication and simplify outreach. Our platform lets you manage SMS, calls, and email campaigns effortlessly. We help you craft personalized messages, schedule broadcasts, and track results, all in one place.",
        image: software6,
        imagePosition: "right",
        desktopImageType: "svg",
    },
];

export const getSoftwareBySlug = (slug: string) =>
    softwareItems.find((item) => item.slug === slug);
